<template>
  <v-dialog
    v-model="dialog"
    :overlay="false"
    max-width="900px"
    transition="dialog-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <div>
        <v-text-field
          outlined
          filled
          name="expectedQty"
          label="Expected Qty"
          id="ExpectedQty"
          :value="TotalQty"
          readonly
        ></v-text-field>
        <v-text-field
          outlined
          name="missingQty"
          label="Extra / Missing Qty"
          id="MissingQty_id"
          :value="missing"
          v-bind="attrs"
          v-on="on"
          readonly
        ></v-text-field>
      </div>
    </template>
    <v-card>
      <v-card-title>
        Missing Qty Form
        <v-spacer></v-spacer>
        <p>{{ missing }}</p>
      </v-card-title>
      <v-card class="px-3 py-2 mb-1 teal darken-4 white--text">
        <!-- <h4>{{ Inv.categ }}</h4> -->
        <template v-for="(item, index) in itemList">
          <div :key="item._id + 'div'">
            <newInventory
              :key="item._id + index"
              :ItemRow="item"
            ></newInventory>
            <v-divider class="white mb-4"></v-divider>
          </div>
        </template>
      </v-card>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    itemList: { type: Array, required: true },
  },
  components: {
    newInventory: () => import("@/components/HQ/_itemRow"),
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    TotalQty() {
      let total = 0;

      total += this.itemList.reduce((total, item) => {
        return total + item.exp;
      }, 0);

      return total.toLocaleString();
    },
    missing() {
      let total = 0;

      total += this.itemList.reduce((total, item) => {
        return total + (item.qty - item.exp);
      }, 0);
      // }

      return total;
    },
  },
};
</script>
